import { TOGGLE_DEVELOPER_MODE } from './actionTypes';

export const toggleDeveloperMode = (dispatch) => {
    dispatch({ type: TOGGLE_DEVELOPER_MODE });
};
